import {
  fetchFilterData,
  fetchInventoryList
} from '@/api/savings-plans/inventory';
import { isFutureMonth } from '@/util/dateTimeUtils';



const getFilterData = (context, payload) => {
  context.commit('SET_IS_FILTER_DATA_LOADING', true);

  fetchFilterData(payload).then((response) => {
    context.commit('SET_IS_FILTER_DATA_LOADING', false);
    context.commit('FILTER_DATA_UPDATED', response);
  }).catch((error) => {
    // eslint-disable-next-line
    context.commit('SET_IS_FILTER_DATA_LOADING', false);
    console.error(error);
  });
};


const getInventoryList = (context, payload) => {
  context.commit('SET_IS_INVENTORY_LIST_LOADING', true);

  fetchInventoryList(payload).then((response) => {
    context.commit('SET_IS_INVENTORY_LIST_LOADING', false);
    context.commit('INVENTORY_LIST_UPDATED', response);
  }).catch((error) => {
    // eslint-disable-next-line
    context.commit('SET_IS_INVENTORY_LIST_LOADING', false);
    console.error(error);
  });
};


const selectedMonthToDate = (context, payload) => {
  context.commit('SET_ACTIVE_MONTH', payload);
};

const setDisplayedWarningBanner = (context, tabName) => {
  context.commit('SET_DISPLAYED_WARNING_BANNER', tabName);
}

const setSelectedViewByOption = (context, selectedViewBy) => {
  context.commit('SET_SELECTED_VIEW_BY_OPTION', selectedViewBy);
}

const setSelectedVendor = (context, selectedVendor) => {
  context.commit('SET_SELECTED_VENDOR', selectedVendor);
}

export default {
  getFilterData,
  getInventoryList,
  setDisplayedWarningBanner,
  selectedMonthToDate,
  setSelectedViewByOption,
  setSelectedVendor
};



// WEBPACK FOOTER //
// ./src/store/modules/savings-plans/inventory/actions.js